// Section spacing halved per EBL-13073 feedback ("Gaps per section reduce by Half").
export const section = {
    position: 'relative',
    py: { xs: 3, md: 4 },
};

export const sectionHeader = {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { md: 'flex-end' },
    justifyContent: { md: 'space-between' },
    gap: 1.5,
    mb: { xs: 1.5, md: 2 },
};

export const eyebrow = {
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    color: 'var(--ecal-lightblue)',
    mb: 1,
};

export const title = {
    fontSize: { xs: '1.5rem', md: '2.25rem' },
    fontWeight: 600,
    color: 'var(--ecal-white)',
};

export const gradientText = {
    background: 'linear-gradient(90deg, #00D7FF 0%, #0078FF 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
};

export const subtitle = {
    color: 'var(--ecal-lightgrey)',
    mt: 1,
    maxWidth: 640,
    fontSize: '0.875rem',
};

export const grid = {
    display: 'grid',
    gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        lg: 'repeat(3, 1fr)',
    },
    gap: 3,
};
